export default {
    GET_RISKS_REQUEST: "GET_RISKS_REQUEST",
    GET_RISKS_SUCCESS: "GET_RISKS_SUCCESS",
    GET_RISKS_FAILURE: "GET_RISKS_FAILURE",
  
    GET_COMPLAINTS_REQUEST: "GET_COMPLAINTS_REQUEST",
    GET_COMPLAINTS_SUCCESS: "GET_COMPLAINTS_SUCCESS",
    GET_COMPLAINTS_FAILURE: "GET_COMPLAINTS_FAILURE",
  
  };
  